import { findIndex, take, dropWhile, map, reject } from 'lodash'
import { i18n } from '@/i18n'

export default {
  /**
   * Returns a string representing the duration in a human friendly format
   *
   * @param Moment\Duration duration
   * @param Object options supports the following options:
   *  mostPreciseUnit: (used to specify how precise to get)
   *  numberOfSignificantParts: (the max significant parts to show)
   *  separator: the character used to separate the string when joining parts
   *  returnType: string representing the desired return type either array or string (default)
   * @return string|Array depending on the return type specified in the options
   * param
   */
  humanizeDurationPrecisely (duration, options = {}) {
    // Split the duration into parts to be able to filter out unwanted ones
    const allParts = [
      { value: duration.years(), unit: 'years' },
      { value: duration.months(), unit: 'months' },
      { value: duration.days(), unit: 'days' },
      { value: duration.hours(), unit: 'hours' },
      { value: duration.minutes(), unit: 'minutes' },
      { value: duration.seconds(), unit: 'seconds' }
      // cannot format with Moment.humanize()
      // { value: duration.milliseconds(), unit: 'milliseconds' },
    ]

    const precisionIndex = findIndex(allParts, { unit: options.mostPreciseUnit || 'seconds' }) + 1
    let filteredParts = allParts

    // Filter out 0 values and any precision we don't want
    filteredParts = take(filteredParts, precisionIndex)
    filteredParts = dropWhile(filteredParts, (part) => part.value === 0)
    filteredParts = reject(filteredParts, (part) => part.value === 0)
    filteredParts = take(filteredParts, options.numberOfSignificantParts || filteredParts.length)

    // I originally tried using moment's existing humanize capability as
    // described here:
    // https://github.com/moment/moment/issues/348#issuecomment-348944860
    // however we still go strings like 'a second' instead of '1 second'.
    // Instead we provide our own translations
    filteredParts = map(filteredParts, (part) => {
      return i18n.tc(`unit_${part.unit}`, part.value, { unit: part.value })
    }
    )

    if (options.returnType === 'array') {
      return filteredParts
    }

    return filteredParts.join(options.separator || ' ')
  }
}
